var React = require('react');
var firebase = require('../../../firebase');
var toastr = require('toastr');
var when = require('when');
var request = require('request');

var { fbStorage } = firebase;

var Button = require('react-bootstrap/lib/Button');
var Modal = require('react-bootstrap/lib/Modal');
var Carousel = require('react-bootstrap/lib/Carousel');
var Form = require('react-bootstrap/lib/Form');
var FormControl = require('react-bootstrap/lib/FormControl');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');

var style = {
	container: {
		margin: 10
	}
};

var Bloqued = React.createClass({

	getInitialState() {
    	return {
            opened: false,
            motivo: "",
    	};
  	},

  	load: function() {
  		var me = this;
  	},

  	send() {
  		var me = this;
        var tokenId = me.props.rowData.tokenId;
        var key = me.props.rowData.id
        me.props.update(key, {status: 0});
        
        var notification = {};
        notification["body"] = me.state.motivo;
        notification["title"] = "Cadastro Bloqueado";
        notification["sound"] = 'buzina.wav';
        
        var data = {};
        data["to"] = tokenId;
        data["priority"] = "high";
        data["notification"] = notification;

        request({
            headers: {
                'Authorization': 'key=AAAA5C4I-e4:APA91bFepe-FC4_lGFT90TT4wpyjTOHnmoMhgqFqLCEqLthZ0bKZDV9QzabigR3rxRwi6B6EuATLQBVUN32-RrLLPDs31Bka4R4tERXkPclxvp1W6CwhDJaGKqL2xh6_LEClu5f7dOdx',
                'Content-Type': 'application/json; charset=UTF-8'
            },
            url: "https://android.googleapis.com/gcm/send",
            method: "POST",
            json: true,
            body: data
        }, function (error, response, body){
        });
  	  	me.close();
  	},

  	open() {
  		
  		var me = this;
  		me.load();
  		this.setState({opened: true});
  	},

  	close() {
  	  this.setState({opened: false});
  	},

  	onInputChange: function(e) {
	    this.setState({[e.target.name]: e.target.value});
	},

	render() {
		var me = this;
		let motivo = me.state.motivo;

    	return (
    		<div>
	    		<Button 
	    			onClick={me.open}
	    			bsSize="small"
	    			bsStyle="primary"
                    style={{backgroundColor: '#B85C5C', borderColor: '#AE4C4C', color: '#FFFFFF'}}>
	    			{"Bloquear"}
	    		</Button>
	    		
	    		<Modal show={me.state.opened} onHide={me.close}>
	    			<div style={style.container}>
		    			<Form onChange={me.onInputChange} className="initOrder activebox">
							<FormGroup  controlId="formBank">
							<ControlLabel>Motivo:</ControlLabel>
								<FormControl 
									name="motivo"
									componentClass="textarea"
									value={motivo}
									placeholder="Motivo"
									onChange={me.onInputChange}
								/>
							</FormGroup>
                            <FormGroup  controlId="formButton">
								<Button onClick={me.send}
										block
										bsStyle="primary"
										style={{width: '50%', backgroundColor: '#B85C5C', borderColor: '#AE4C4C', color: '#FFFFFF'}}>
										{"Bloquear"}
								</Button>
							</FormGroup>
						</Form>
					</div>
				</Modal>
	    	</div>
    	);
  	}

});

module.exports = Bloqued;


// WEBPACK FOOTER //
// ./src/components/Admin/Couriers/Bloqued.jsx